import Tooltip from "@mui/material/Tooltip";
import { IconButton } from "@mui/material";
import PreviewIcon from "@mui/icons-material/Preview";

export default function ToggleSelectBtn({ onClick }) {
  return (
    <Tooltip title="Checkbox">
      <IconButton onClick={onClick}>
        <PreviewIcon />
      </IconButton>
    </Tooltip>
  );
}
